import { HeartCommon } from "@components";
import {
    selectAccount,
    selectAuth,
    selectFavoriteTours,
    updateFavorite,
    useAppDispatch,
    useAppSelector,
} from "@redux";
import { PATH_LOGIN } from "@routes";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ErrorToast } from "src/Components/toasts/ErrorToast";

interface HeartTourModuleProps {
    productId: string | number;
}

export const HeartTourModule = ({ productId }: HeartTourModuleProps) => {
    const dispatch = useAppDispatch();
    const favoriteState = useAppSelector(selectFavoriteTours);
    const { tours, loading } = favoriteState;
    const { jwt } = useAppSelector(selectAuth);
    const { account } = useAppSelector(selectAccount);
    const [isSignedIn, setIsSignedIn] = useState(!_.isNil(jwt) && !_.isNil(account));
    const navigate = useNavigate();
    const location = useLocation();
    const shouldShowLoading = loading && !_.isNil(jwt) && !_.isNil(account);

    useEffect(() => {
        setIsSignedIn(!_.isNil(jwt) && !_.isNil(account));
    }, [jwt, account]);

    const liked =
        tours?.some(
            (tour) =>
                (tour?.tdms_product_id ?? tour?.productId)?.toString() === productId.toString(),
        ) ?? false;

    const handleToggle = () => {
        if (!isSignedIn) {
            ErrorToast({ Message: "Please login first to add favorites" });
            const returnPath = encodeURIComponent(location.pathname + location.search);
            navigate(`${PATH_LOGIN}?returnPath=${returnPath}`);
            return;
        }
        if (shouldShowLoading) return;
        const method = liked ? 0 : 1;
        dispatch(updateFavorite({ productId, method }));
    };

    return <HeartCommon active={liked} loading={shouldShowLoading} onClick={handleToggle} />;
};
